<template>
  <div id="app">
    <head-component v-if="isShow"></head-component>
    <!-- :key="$route.fullPath" -->
    <router-view class="content"></router-view>
    <foot-component></foot-component>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {};
  },
  watch: {
    $route: {
      handler: function(t, f) {
        console.log("t.name", t.name);
        if (t.name == "login" || t.name == "download") {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      defaultIcon:
        'this.src="' + require("./assets/images/defaultimg.png") + '"',
      isShow: false,
      isRouterAlive: true
    };
  },
  methods: {
    isMobileToWap() {
      var sUserAgent = navigator.userAgent;
      console.log(sUserAgent);
      if (
        sUserAgent.indexOf("Android") > -1 ||
        sUserAgent.indexOf("iPhone") > -1 ||
        sUserAgent.indexOf("Symbian") > -1
      ) {
        location.href = "http://m.dgsjyyy.com";
      }
    }
  },
  created() {
    this.isMobileToWap();
    this.$store.dispatch("sessionData/refreshUserInfo");
    this.$store.dispatch("sessionData/getBaseInfo");
    this.$store.dispatch("sessionData/getNotice", { articleCategoryId: 3 });
    this.$store.dispatch("sessionData/getNotice", { articleCategoryId: 7 });
    this.$store.dispatch("sessionData/getNavbar");
    this.$store.dispatch("sessionData/getTree");
    this.$store.dispatch("getCartNum");
  }
};
</script>

<style lang="scss">
@import "./assets/css/common.css";
@media screen and (max-width: 1200px) {
  html {
    width: 1200px;
  }
}
@media screen and (max-width: 1024px) {
  html {
    zoom: 0.8;
  }
  .tool-box {
    margin: 0 !important;
    right: -10px !important;
    transform: translateX(100%);
  }
}
.content {
  // background: $theme-bg;
}
#app {
  height: 100%;
}
.el-popover {
  background: #ffffff !important;
}

/*带背景的分页按钮背景色begin*/
.el-pagination.is-background .el-pager li:not(.disabled) {
  border: 1px solid #bfbfbf;
  background-color: #fff;
  color: #bfbfbf;
  font-size: 13px;
  border-radius: 4px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fa4b4b !important;
  color: #fff;
  border: 1px solid transparent;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #ffffff !important;
  background-color: #fa4b4b !important;
  border: 1px solid #fa4b4b !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #fa4b4b !important;
  color: #fff;
}
/*带背景的分页按钮背景色end*/

/*不带背景的分页按钮背景色begin*/
.el-pager li.active {
  color: #08c0b9;
  cursor: default;
}
.el-pagination .el-pager li:hover {
  color: #08c0b9;
}
.el-pagination .el-pager li:not(.disabled):hover {
  color: #08c0b9;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: #ffffff !important;
  border: 1px solid #cccccc;
  min-width: 28px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue